import { render, staticRenderFns } from "./packages_list_app.vue?vue&type=template&id=4ad91cbd&"
import script from "./packages_list_app.vue?vue&type=script&lang=js&"
export * from "./packages_list_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports